import styled from "styled-components";

export const Content = styled.div`
  width: 100%;
`;

export const Wrapper = styled.header`
  display: flex;
  justify-content: center;
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  max-width: 1400px;
  width: 100%;
  padding: 40px 16px;
  margin: 0 auto;

  @media (min-width: 1200px) {
    padding: 40px 120px;
  }

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
export const LogoImg = styled.img`
  width: 157px;
`;
export const RightBox = styled.div`
  display: flex;
`;

export const BtnMenubox = styled.div`
  display: none;

  @media (min-width: 1150px) {
    display: flex;
    gap: 24px;
  }
`;

export const BtnMenu = styled.button`
  font-size: 16px;
`;
export const ActionBtn = styled.button`
  background-color: var(--orange-500);
  border: 1px solid var(--orange-500);

  @media (min-width: 1150px) {
    margin-left: 48px;

    &:hover{
      background-color: var(--orange-650);
      color: var(--white);
      background: linear-gradient(var(--orange-650) 85%, #FF7022 100%);
    }
  }
`;
